import { useLocation } from "react-router-dom";
import { SuperAdminList, StoreAdminList } from "../components";

export const AdminUsersList = () => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  return isStoreAdmin ? <StoreAdminList /> : <SuperAdminList />;
};
